/** Legal document types shown during sign-up */
export enum LegalModel {
  PRIVACY_POLICY = 'privacy',
  TERMS_OF_SERVICE = 'tac',
  IMPRINT = 'imprint',
}
